import React from 'react';
import { Fade, Typography } from '@mui/material';
import './LoaderComponent.css';

function LoaderComponent({
    isPopup = false,
    title = '',
    message = 'Chargement en cours...',
}) {
    const loaderModeClass = isPopup ? 'loader--popup' : 'loader--page';
    const loaderContentClass = isPopup ? 'loaderContentPopup' : 'loaderContent';
    const logoSource = '/asset/image/lv_0_20251221193520.mp4.svg';

    return (
        <Fade in timeout={420}>
            <div className={`loader ${loaderModeClass}`} role="status" aria-live="polite" aria-busy="true">
                <div className={loaderContentClass}>
                    {!isPopup && (
                        <div className="loaderVisual" aria-hidden="true">
                            <div className="loaderGlow" />
                            <img src={logoSource} alt="" className="loaderLogo" />
                        </div>
                    )}
                    {!isPopup && title && (
                        <Typography component="p" className="loaderTitle">
                            {title}
                        </Typography>
                    )}
                    <div className="loaderActivity" aria-hidden="true">
                        <div className="loaderBounce">
                            <span className="loaderBounceLayer loaderBounceLayer--one" />
                            <span className="loaderBounceLayer loaderBounceLayer--two" />
                        </div>
                    </div>
                    <Typography component="p" className="loaderMessage">
                        {message}
                    </Typography>
                </div>
            </div>
        </Fade>
    );
}

export default LoaderComponent;
